export const CheckboxCheck = () => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.10448 0.813964C8.44229 0.542207 8.93874 0.563801 9.25126 0.877243C9.56376 1.19072 9.5817 1.68504 9.30567 2.01876L9.24624 2.08288L3.88147 7.375L0.745819 4.20689L0.688062 4.14194C0.416006 3.80494 0.439565 3.31099 0.755864 3.00125C1.0721 2.69186 1.56824 2.67658 1.90265 2.95213L1.96794 3.01125L3.89487 4.95874L8.03919 0.872248L8.10448 0.813964Z"
      fill="white"
    />
  </svg>
);
